<template>
    <dialog-or-bottom-sheet v-model="internalValue" persistent max-width="500">
        <v-card>
            <v-card-title>
                Progresso do processamento
            </v-card-title>

            <v-card-text>
                O progresso deste processamento será atualizado em tempo real
            </v-card-text>

            <v-card-text>
                {{ item }}
                <v-progress-linear rounded height="24" :value="lastProgressValue || 0"></v-progress-linear>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="close">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </dialog-or-bottom-sheet>
</template>

<script>
import Api from '@/lib/Api';

export default {
    name: 'ProcessingCheckDialog',
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        formResponseId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            intervalId: null,
            lastProgressValue: 0,
            item: null
        }
    },
    computed: {
        internalValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
    },
    watch: {
        internalValue(val) {
            if (val) {
                this.startPolling()
            } else {
                this.stopPolling()
            }
        },
    },
    mounted() {
        this.startPolling();
    },
    methods: {
        close() {
            this.internalValue = false
            this.$emit('closed')
        },
        startPolling() {
            this.stopPolling()

            this.fetchProgress()

            this.intervalId = setInterval(() => {
                this.fetchProgress()
            }, 5000)
        },
        stopPolling() {
            if (this.intervalId) {
                clearInterval(this.intervalId)
                this.intervalId = null
            }
        },
        async fetchProgress() {
            try {
                const resp = await Api.getFormResponseProcessingProgress(this.formResponseId);

                if (!resp.error && resp.message) {
                    this.item = resp.message.processing_item;
                    this.lastProgressValue = resp.message.processing_progress || 0;

                    if (resp.message.status && resp.message.status === 4) {
                        this.item = "PROCESSAMENTO CONCLUÍDO";
                        this.lastProgressValue = 100;
                    }
                }
            } catch (err) {
                console.error('Erro ao buscar progresso:', err)
            }
        },
    },
    beforeDestroy() {
        this.stopPolling()
    },
}
</script>
